import { Component, computed, inject, output } from '@angular/core';
import { UiService } from '../../services/ui.service';
import { I18nService } from '../../services/i18n.service';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NavButtonComponent } from '../nav-button/nav-button';

@Component({
  selector: 'app-scan-upload-popup',
  imports: [NzModalModule, NavButtonComponent],
  templateUrl: './scan-upload-popup.html',
  styleUrls: ['./scan-upload-popup.scss'],
})
export class ScanUploadPopupComponent {
  scanClicked = output<void>();
  uploadClicked = output<void>();
  popupClosed = output<void>();

  private ui = inject(UiService);
  public i18n = inject(I18nService);

  // Computed
  readonly isMobile = computed(() => this.ui.IsMobile());
}
